export const PLANNING_VIEWS = [
  ['week', 'Semaine'],
  ['day', 'Jour'],
  ['month', 'Mois'],
  ['resources', 'Ressources'],
  ['load', 'Charge'],
  ['deadlines', 'Échéances'],
];

export const ELEMENT_TYPE_KEYS = ['task', 'event', 'meeting', 'intervention', 'absence', 'unavailable', 'milestone'];
export const ELEMENT_TYPES = {
  task: 'Tâche planifiée',
  event: 'Événement',
  meeting: 'Réunion',
  intervention: 'Intervention',
  absence: 'Absence',
  unavailable: 'Indisponibilité',
  milestone: 'Jalon / échéance',
};

export const LEGACY_ELEMENT_TYPE_MAP = {
  interne: 'event', external: 'meeting', externe: 'meeting', caldav: 'event',
  evenement: 'event', event: 'event', reunion: 'meeting', meeting: 'meeting',
  intervention: 'intervention', absence: 'absence', indisponibilite: 'unavailable', unavailable: 'unavailable',
  tache: 'task', task: 'task', jalon: 'milestone', echeance: 'milestone', milestone: 'milestone',
};

export const PLANNING_STATUS = {
  PLANNED: 'planned', IN_PROGRESS: 'in_progress', COMPLETED: 'completed', CANCELLED: 'cancelled',
};
export const STATUS_LABELS = { planned: 'Planifié', in_progress: 'En cours', completed: 'Terminé', cancelled: 'Annulé' };
export const LEGACY_STATUS_MAP = {
  planifie: 'planned', planned: 'planned', a_faire: 'planned',
  en_cours: 'in_progress', in_progress: 'in_progress',
  termine: 'completed', terminee: 'completed', completed: 'completed', done: 'completed',
  annule: 'cancelled', annulee: 'cancelled', cancelled: 'cancelled', canceled: 'cancelled',
};

export const PLANNING_SYNC_STATUS = {
  NOT_CONFIGURED: 'not_configured', NOT_SYNCED: 'not_synced', PENDING: 'pending', SYNCING: 'syncing',
  SYNCED: 'synced', ERROR: 'error', EXTERNAL_ONLY: 'external_only',
};
export const SYNC_LABELS = {
  not_configured: 'CalDAV non configuré', not_synced: 'Non synchronisé', pending: 'À synchroniser',
  syncing: 'Synchronisation en cours', synced: 'Synchronisé', error: 'Erreur', external_only: 'Externe uniquement',
};
export const LEGACY_SYNC_STATUS_MAP = {
  synchronise_caldav: 'synced', synchronise: 'synced', synced: 'synced',
  a_synchroniser: 'pending', pending: 'pending', error: 'error', erreur: 'error',
  external_only: 'external_only', not_synced: 'not_synced', not_configured: 'not_configured', syncing: 'syncing',
};

export const PRIORITY_LABELS = { low: 'Basse', normal: 'Normale', high: 'Haute', critical: 'Critique' };
export const WORKDAY = { startHour: 8, endHour: 18, dailyHours: 8, workingDays: [1, 2, 3, 4, 5] };
